export function parseStringRecord(value: unknown): Record<string, string> {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    throw new TypeError('Expected a string record');
  }
  const prototype = Reflect.getPrototypeOf(value);
  if (prototype !== Object.prototype && prototype !== null) {
    throw new TypeError('Expected a string record');
  }
  for (const entry of Object.values(value)) {
    if (typeof entry !== 'string') throw new TypeError('Expected a string record');
  }
  return value as Record<string, string>;
}
